import { SharedModule } from "@modules/shared/shared.module";

import { GlobalToastModule } from "@core/components/global-toast/global-toast.module";
import { SpinnerModule } from "@core/components/spinner/spinner.module";
import { AplicationHttpClientModule } from "@core/config/application-http-client/application-http-client.module";
import { YmLaraPreset } from "@core/config/theme/ym-lara-preset";
import { TranslationModule } from "@core/config/translation/translation.module";
import { AutorizationInterceptor } from "@core/interceptors/authorization.intercetor";
import { RequestInterceptor } from "@core/interceptors/request.interceptor";
import { TenantInterceptor } from "@core/interceptors/tenant.interceptor";
import { AuthRequest } from "@core/requests/auth.request";
import { AuthenticationService } from "@core/services/authentication.service";
import { AuthorizationService } from "@core/services/authorization.service";
import { CacheService } from "@core/services/cache.service";
import { SidebarService } from "@core/services/sidebar.service";
import { SpinnerService } from "@core/services/spinner.service";
import { TenantService } from "@core/services/tenant.service";
import { ToastService } from "@core/services/toast.service";
import { UserProfileState } from "@core/state/user-profile.state";

import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from "ngx-google-analytics";

import { providePrimeNG } from "primeng/config";

import { registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import ptBr from "@angular/common/locales/pt";
import { LOCALE_ID, NgModule, Provider } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { environment } from "@/environments/environment";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

registerLocaleData(ptBr);

const customProviders: Provider[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AutorizationInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TenantInterceptor,
    multi: true,
  },
  {
    provide: LOCALE_ID,
    useValue: "pt-BR",
  },
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    SharedModule,
    BrowserAnimationsModule,
    GlobalToastModule,
    TranslationModule,
    SpinnerModule,
    NgxGoogleAnalyticsModule.forRoot(environment.analyticsId),
    NgxGoogleAnalyticsRouterModule,
  ],
  exports: [],
  providers: [
    ...customProviders,
    providePrimeNG({
      theme: {
        preset: YmLaraPreset,
        options: {
          darkModeSelector: ".app-dark",
          cssLayer: {
            name: "primeng",
            order: "primeng",
          },
        },
      },
    }),
    AplicationHttpClientModule,
    AuthRequest,
    AuthenticationService,
    ToastService,
    AuthorizationService,
    TenantService,
    UserProfileState,
    CacheService,
    SpinnerService,
    SidebarService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
